import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Input,
    Table,
    Spinner,
    Button,
    Label,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
} from "reactstrap";
import { entrepotActions } from "../../sagas/entrepotSlice";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { stockActions } from "../../sagas/stockSlice";
import POSHeader from "./POSHeader";
import VirtualKeypad from "./VirtualKeypad";
import { useNavigate } from "react-router-dom";
import { CBL_PAGE, CPMT_PRODUCTS_PAGE, CPMT_RECEPTION_PAGE, CPMT_STOCK_PAGE, CPMT_TRANSFER_PAGE, PAY_PAGE, RETOUR_PAGE } from "../../routes/routeConstants";
import './POSMouvementStock.css';
import POSKeypadModal from "./POSKeypadModal";
import { FaSearch, FaTimes } from "react-icons/fa";

const POSMouvementStock = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    // Local filters
    const [entrepotId, setEntrepotId] = useState("");
    const [query, setQuery] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const { entrepots } = useSelector(state => state.entrepots);
    const { businessName, email, address, telephone, fullName, commercialId, pointOfSaleId } = useSelector((state) => state.auth);
    const searchInputRef = useRef(null);
    const [showSearchKeypad, setShowSearchKeypad] = useState(false);

    const mouvements = useSelector((state) => state.stock.stocks || []);
    const loading = useSelector((state) => state.stock.loading);

    // Touchpad states
    const [showKeypad, setShowKeypad] = useState(false);
    const [activeInput, setActiveInput] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const [tempDateFrom, setTempDateFrom] = useState("");
    const [tempDateTo, setTempDateTo] = useState("");
    const navigate = useNavigate();


    useEffect(() => {
        // F2 focus search
        const handleKeyDown = (e) => {
            if (e.key === "F2") {
                e.preventDefault();
                setShowSearchKeypad(true);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);



    // Load mouvements when filters change
    const searchMouvements = () => {
        dispatch(
            stockActions.getMouvements({
                entrepotId: entrepotId || null,
                dateFrom: dateFrom || null,
                dateTo: dateTo || null,
                query: query || null,
            })
        );
    };

    const entrepotOptions = entrepots?.map(entrepot => ({
        value: entrepot.id,
        label: entrepot.code + ' - ' + entrepot.libelle,
    })) ?? [];

    const entrepotOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...entrepotOptions
    ];

    useEffect(() => {
        dispatch(entrepotActions.list());
    }, []);

    useEffect(() => {
        searchMouvements();
    }, [entrepotId, dateFrom, dateTo]);



    return (
        <Container fluid className="p-2 touch-optimized">
            <POSHeader
                businessName={businessName || "MATJARPOS"}
                commercialId={commercialId}
                pointOfSaleId={pointOfSaleId}
                fullName={fullName}
                activeTab={"TRANSFER"}
                onChangeTab={(tab) => {
                    if (tab === "VENTES") navigate(CBL_PAGE);
                    if (tab === "STOCK") navigate(CPMT_STOCK_PAGE);
                    if (tab === "PRODUCTS") navigate(CPMT_PRODUCTS_PAGE);
                    if (tab === "AVANCE") navigate(PAY_PAGE);
                    if (tab === "RETOURS") navigate(RETOUR_PAGE);
                    if (tab === "RECEPTION") navigate(CPMT_RECEPTION_PAGE);
                    if (tab === "TRANSFER") navigate(CPMT_TRANSFER_PAGE);
                }}
            />

            <Card className="pos-toolbar-card">
                <CardBody className="pos-toolbar-body">
                    <div className="pos-toolbar-left">
                        <div className="pos-title">
                            Mouvements de Stock
                        </div>


                    </div>


                </CardBody>
            </Card>

            <Card className="pos-card mt-2">
                <CardBody className="pos-card-body">
                    <Row className="g-2 align-items-end">
                        <Col lg={6} md={6} sm={12}>
                            <FormGroup className="mb-0">
                                <Label className="pos-label">{t("reglement.search")}</Label>

                                <div className="pos-input-group">
                                    <Input
                                        innerRef={searchInputRef}
                                        value={query}
                                        readOnly
                                        inputMode="none"
                                        placeholder="Rechercher..."
                                        className="pos-input text-uppercase"
                                        onClick={() => setShowSearchKeypad(true)}
                                    />
                                    <Button
                                        color="primary"
                                        type="button"
                                        className="pos-side-btn"
                                        onClick={() => setShowSearchKeypad(true)}
                                    >
                                        <FaSearch />
                                    </Button>

                                    {query ? (
                                        <Button
                                            color="light"
                                            type="button"
                                            className="pos-side-btn"
                                            onClick={() => {
                                                setQuery("");
                                                dispatch(
                                                    stockActions.getMouvements({
                                                        entrepotId: entrepotId || null,
                                                        dateFrom: dateFrom || null,
                                                        dateTo: dateTo || null,
                                                        query: "" || null,
                                                    })
                                                );
                                            }}
                                        >
                                            <FaTimes />
                                        </Button>
                                    ) : null}
                                </div>
                            </FormGroup>
                        </Col>

                        <Col lg={3} md={3} sm={6} xs={6}>
                            <FormGroup className="mb-0">
                                <Label className="pos-label">Date début</Label>
                                <Input
                                    type="date"
                                    value={dateFrom}
                                    className="pos-input"
                                    onChange={(e) => setDateFrom(e.target.value)}
                                />
                            </FormGroup>
                        </Col>

                        <Col lg={3} md={3} sm={6} xs={6}>
                            <FormGroup className="mb-0">
                                <Label className="pos-label">Date fin</Label>
                                <Input
                                    type="date"
                                    value={dateTo}
                                    className="pos-input"
                                    onChange={(e) => setDateTo(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </CardBody>
            </Card>


            <Card className="pos-card mt-2">
                <CardBody className="pos-card-body p-0">
                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t("common.loading")}</div>
                        </div>
                    ) : (
                        <div className="pos-table-wrap">
                            <table className="table table-hover table-striped table-bordered mb-0 pos-table">
                                <thead className="pos-thead">
                                    <tr>
                                        <th>Date</th>
                                        <th>Article</th>
                                        <th>Type</th>
                                        <th>Qté</th>
                                        <th>Entrepôt</th>
                                        <th>Motif</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(mouvements || []).map((m) => (
                                        <tr key={m.id}>
                                            <td className="fw-bold">
                                                {m.dateMouvement?.replace("T", " ").slice(0, 16)}
                                            </td>
                                            <td>
                                                <strong>{m.articleNom}</strong>
                                                <div className="text-muted small">{m.articleCode}</div>
                                            </td>
                                            <td>
                                                <span className={`badge fs-6 px-3 py-2
            ${m.typeMouvement === "ENTREE" ? "bg-success" :
                                                        m.typeMouvement === "SORTIE" ? "bg-danger" : "bg-warning"}`}>
                                                    {m.typeMouvement}
                                                </span>
                                            </td>
                                            <td className="fs-5 fw-bold">{m.quantite}</td>
                                            <td>{m.typeMouvement === "RETOUR_CLIENT" || m.typeMouvement === "ENTREE" || m.typeMouvement === "TRANSFERT" ?
                                                m.entrepotDestinationNom :
                                                m.entrepotSourceNom}</td>
                                            <td>{m.motif || "-"}</td>
                                        </tr>
                                    ))}
                                    {(!mouvements || mouvements.length === 0) && (
                                        <tr>
                                            <td colSpan="8" className="text-center py-4">
                                                <div className="text-muted">{t("stock.noMouvements")}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                        </div>
                    )}
                </CardBody>
            </Card>


            <POSKeypadModal
                isOpen={showSearchKeypad}
                toggle={() => setShowSearchKeypad(false)}
                value={query || ''}
                onChange={(val) => {
                    const value = (val || "").toUpperCase();
                    setQuery(value);
                    searchMouvements();
                }}
                onSearch={() => setShowSearchKeypad(false)}
                title={t("reglement.search") || "Recherche"}
            />

        </Container>
    );
};

export default POSMouvementStock;